import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { formatDate } from "utils/dates";
import { InsuranceCompanyContext } from "./insurance-company-provider";
import TableSortableHeader from "components/ui/table-sortable-header";
import { useSort } from "hooks";
import { Waiting } from "components/ui";

export const InsuranceChangeLogs = () => {
  const {
    insuranceChangeLogs,
    getInsuranceChangeLogs,
    isFetchingInsuranceChangeLogs
  } = useContext(InsuranceCompanyContext);

  useEffect(() => {
      getInsuranceChangeLogs();
  }, []);

  const { ascending, sortBy, getSortedArray, toggleSortDirection, setSortBy } =
    useSort({ by: "changed_date", ascending: false });

  return (
    <div class="query-table-container scrollable">
        {isFetchingInsuranceChangeLogs && <Waiting />}
        <table class="query-table dynamic-columns">
            <TableSortableHeader
                columns={[
                { key: "changed_date", text: "Time" },
                { key: "changed_by_name", text: "User" },
                { key: "changed_field", text: "Changes" },
                ]}
                sortBy={sortBy}
                ascending={ascending}
                setSortBy={setSortBy}
                toggleSortDirection={toggleSortDirection}
            />
            <tbody>
                {getSortedArray(insuranceChangeLogs).map(d => (
                <tr key={d.id}>
                    <td>
                    {formatDate(d.changed_date, "MMM DD, YYYY hh:mm A")}
                    </td>
                    <td>{d.changed_by_name}</td>
                    <td>{d.changed_field} changed from {d.old_value} to {d.new_value}</td>
                </tr>
                ))}
            </tbody>
        </table>
    </div>
  );
};
